export const Modifiers = {
  // TODO replace these with Result
  cancel: 'cancel',
  click: 'click',
  create: 'create',
  error: 'error',
  open: 'open',
  save: 'save',
  send: 'send',
  success: 'success',
  update: 'update',
}

export const AnalyticsType = {
  action: 'action',
  backend: 'backend',
  modal: 'modal',
  paywall: 'paywall',
}

export const PremiumModalOrigin = {
  // TODO figure out what this is used for?
  Banking: 'Banking',
  ConvertEstimateToDraft: 'ConvertEstimateToDraft',
  Customers: 'Customers',
  Dashboard: 'Dashboard',
  DownpaymentOrScheduleModal: 'DownpaymentOrScheduleModal',
  EditReminderModal: 'EditReminderModal',
  EmailAttachment: 'EmailAttachment',
  InvoiceList: 'invoiceList',
  MainMenu: 'MainMenu',
  MyPlansPage: 'MyPlansPage',
  MyReminders: 'MyReminders',
  NewTradename: 'NewTradename',
  RecurringProfile: 'RecurringProfile',
  ReminderEmailModal: 'ReminderEmailModal',
  ReminderPostModal: 'ReminderPostModal',
  SendEInvoice: 'SendEInvoice',
  SendInvoice: 'SendInvoice',
  SendPaperInvoice: 'SendPaperInvoice',
  SusbcriptionInfoBox: 'SusbcriptionInfoBox',
  TrackerPage: 'TrackerPage',
  DocumentCustomisation: 'DocumentCustomisation',
  EmailConsumablesCheckBox: 'EmailConsumablesCheckBox',
  ConsumablesInfo: 'ConsumablesInfo',
}

export const Category = {
  ageras: 'ageras',
  bankConnection: 'bankConnection',
  banking: 'banking', // TODO choose one or the other
  customer: 'customer',
  document: 'document',
  draft: 'draft',
  financing: 'financing',
  invoiceSettings: 'invoiceSettings',
  navigation: 'navigation',
  notification: 'notification',
  product: 'product',
  onlinePayment: 'onlinePayments',
  paymentSchedule: 'paymentSchedule',
  recurringInvoice: 'recurringInvoice',
  referral: 'referral',
  reminder: 'reminder',
  report: 'report',
  setting: 'settings',
  subscription: 'subscription',
  tracker: 'tracker',
  user: 'user',
  consumables: 'consumables',
}

export const AnalyticsObject = {
  creditNote: 'creditnote',
  deliveryNote: 'deliverynote',
  estimate: 'estimate',
  invoice: 'invoice',
  receipt: 'receipt',
  reminder: 'reminder',
  null: 'NULL',
}

export const Placement = {
  bankConnection: 'bankConnection',
  companySettingsModal: 'companySettingsModal',
  customers: 'customers',
  dashboard: 'dashboard',
  deliverynotes: 'deliverynotes',
  editor: 'editor',
  estimates: 'estimates',
  financing: 'financing',
  invoices: 'invoices',
  myAccount: 'myAccount',
  notification: 'notification',
  preview: 'preview',
  products: 'products',
  receipts: 'receipts',
  recurringProfiles: 'recurringProfiles',
  reports: 'reports',
  subscriptionModal: 'subscription-modal',
  subscriptionTab: 'subscriptionTab',
  supportModal: 'supportModal',
  tracker: 'tracker',
}

export const Result = {
  success: 'success',
  open: 'open',
  close: 'close',
  cancel: 'cancel',
  error: 'error',
  click: 'click',
  display: 'display',
  save: 'save',
  readMore: 'readMore',
  contactUsDiscount: 'contactUsDiscount',
} as const

export const Events = {
  activateOLPModal: 'activateOLPModal',
  activatePaymentSchedule: 'activatePaymentSchedule',
  addCustomer: 'addCustomer',
  addLogo: 'addLogo',
  addProduct: 'addProduct',
  addTrackerEntry: 'addTrackerEntry',
  addTradeName: 'addTradeName',
  applyPromocode: 'applyPromoCode',
  approveDocument: 'approveDocument',
  approveRecurringInvoice: 'approveRecurringInvoice',
  applyForFinancing: 'applyForFinancing',
  applyForBusinessLoan: 'applyForBusinessLoan',
  bankConnectionLoginPopup: 'bankConnectionLoginPopup',
  bankConnectionPaywall: 'bankConnectionPaywall',
  bankingBlock: 'bankingBlock',
  bankingPaywall: 'bankingPaywall',
  blockedAccount: 'blockedAccount',
  businessLoanSettings: 'businessLoanSettings',
  ccExpiryPaymentMethodUpdate: 'ccExpiryPaymentMethodUpdate',
  cancelDowngrade: 'cancelDowngrade',
  changeInvoiceQuota: 'changeInvoiceQuota',
  changeBillingCycle: 'changeBillingCycle',
  changeReportPeriod: 'changeReportPeriod',
  changeTrackerTab: 'changeTrackerTab',
  copyReferralLink: 'copyReferralLink',
  clickUpgradeSubscription: 'clickUpgradeSubscription',
  clickDashboardCarousel: 'clickDashboardCarousel',
  clickDowngradeSubscription: 'clickDowngradeSubscription',
  companySearchSelect: 'companySearchSelect',
  connectBank: 'connectBank',
  connectBankModal: 'connectBankModal',
  consumablesPaywall: 'consumablesPaywall',
  continueToKyc: 'continueToKyc',
  customerLimitPaywall: 'customerLimitPaywall',
  deActivateOLP: 'deActivateOLP',
  deleteAccount: 'deleteAccount',
  deleteCustomer: 'deleteCustomer',
  deleteDocument: 'deleteDocument',
  deleteDraft: 'deleteDraft',
  deleteProduct: 'deleteProduct',
  deleteRecurringInvoice: 'deleteRecurringInvoice',
  deleteTrackerEntries: 'deleteTrackerEntries',
  deleteTradeName: 'deleteTradeName',
  deSelectInvoiceAttachment: 'deSelectInvoiceAttachment',
  disconnectBank: 'disconnectBank',
  downloadDeliveryNote: 'downloadDeliveryNote',
  downloadReceipt: 'downloadReceipt',
  downloadReport: 'downloadReport',
  editAutomaticPaymentReminders: 'editAutomaticPaymentReminders',
  editCustomer: 'editCustomer',
  editDocument: 'editDocument',
  editInvoiceCreditNoteWarning: 'editInvoiceCreditNoteWarning', // TODO
  editPaymentSchedule: 'editPaymentSchedule',
  editProduct: 'editProduct',
  editRecurringInvoice: 'editRecurringInvoice',
  editSettings: 'editSettings',
  editSubscriptionPaymentMethod: 'ui:editSubscriptionPaymentMethod',
  editTrackerEntry: 'editTrackerEntry',
  estimatePaywall: 'estimatePaywall',
  financingPartnerPageVisit: 'financingPartnerPageVisit',
  financingApplicationConfirmationModalClose: 'financingApplicationConfirmationModalClose',
  findAccountant: 'findAccountant',
  findAccountantVerification: 'findAccountantVerification',
  resendVerificationCode: 'resendVerificationCode',
  firstSubscription: 'firstSubscription',
  finishBusinessLoanApplication: 'finishBusinessLoanApplication',
  freeInvoiceLimit: 'freeInvoiceLimit',
  goToHelpCenter: 'goToHelpCenter',
  goToAgerasMarketplace: 'goToAgerasMarketplace',
  goToAgerasMarketplacePortal: 'goToAgerasMarketplacePortal',
  hideTransaction: 'hideTransaction',
  importCustomers: 'importCustomers',
  importProducts: 'importProducts',
  invoiceNumber: 'invoiceNumber',
  leaveWithoutSaving: 'leaveWithoutSaving',
  loadTransactions: 'loadTransactions',
  logoCropping: 'logoCropping',
  manageAccounts: 'manageAccounts',
  matchInvoice: 'matchInvoice',
  newCancelSubscriptionFlow: 'newCancelSubscriptionFlow',
  navigateToBankingPage: 'navigateToBankingPage',
  newDocument: 'newDocument',
  newRecurringInvoice: 'newRecurringInvoice',
  notificationLink: 'notificationLink',
  olpSignup: 'olpSignup',
  olpSignupModal: 'olpSignupModal',
  openDocument: 'openDocument',
  openRecurringInvoice: 'openRecurringInvoice',
  paymentSchedulePaywall: 'paymentSchedulePaywall',
  premiumPlansConfirmation: 'premiumPlansConfirmation',
  premiumPlansModal: 'premiumPlansModal',
  previewDocument: 'previewDocument',
  previewRecurringInvoice: 'previewRecurringInvoice',
  recurringInvoicePaywall: 'recurringInvoicePaywall',
  redeemPromoCode: 'redeemPromoCode',
  reminderSettingsPaywall: 'reminderSettingsPaywall',
  requestDiscount: 'requestDiscount',
  requestFinancingQuote: 'requestFinancingQuote',
  recieveFinancingQuote: 'recieveFinancingQuote',
  saveDraft: 'saveDraft',
  saveOnLeave: 'saveOnLeave',
  saveRecurringInvoice: 'saveRecurringInvoice',
  searchMoreCustomers: 'searchMoreCustomers',
  selectAccounts: 'selectAccounts',
  selectBank: 'selectBank',
  selectColoredAreas: 'selectColoredAreas',
  selectColumnHeader: 'selectColumnHeader',
  selectInvoiceAttachment: 'selectInvoiceAttachment',
  selectMainColor: 'selectMainColor',
  selectMainFont: 'selectMainFont',
  selectPaymentSchedule: 'selectPaymentSchedule',
  sendDocumentAfterFinancingRequest: 'sendDocumentAfterFinancingRequest',
  sendByEmail: 'sendByEmail', // TODO fix the remaining sendByEmail events
  sendDocument: 'sendDocument',
  sendForFinancingOffer: 'sendForFinancingOffer',
  sendManualReminder: 'sendManualReminder',
  sendPaywall: 'sendPaywall',
  sendRecurringInvoice: 'sendRecurringInvoice',
  sentForFinancing: 'sentForFinancing',
  setDocumentStatus: 'setDocumentStatus',
  setInvoicePeriod: 'setInvoicePeriod',
  setInvoiceAmountRange: 'setInvoiceAmountRange',
  setRecurringInvoiceStatus: 'setRecurringInvoiceStatus',
  setSetting: 'setSetting',
  setTransactionPeriod: 'setTransactionPeriod',
  showOnlyReferenceNumberMatches: 'showOnlyReferenceNumberMatches',
  signupComplete: 'signupComplete',
  switchAccount: 'switchAccount',
  switchBankConnectionTab: 'switchBankConnectionTab',
  toggleAutomaticReminder: 'toggleAutomaticReminder',
  toggleEnableTink: 'toggleEnableTink',
  toggleMakeRecurring: 'toggleMakeRecurring',
  trackerPaywall: 'trackerPaywall',
  tradeNamePaywall: 'tradeNamePaywall',
  transferEntriesToInvoice: 'transferEntriesToInvoice',
  unhideTransaction: 'unhideTransaction',
  unmatchInvoice: 'unmatchInvoice',
  upgradeSubscription: 'upgradeSubscription',
  upgradeSubscriptionSuccess: 'ui:UpgradeSubscriptionSuccess', // TODO
  viewDocument: 'viewDocument',
  viewNotifications: 'viewNotifications',
  viewFinancingTab: 'viewFinancingTab',
  viewOutstandingInvoices: 'viewOutstandingInvoices',
  welcome: 'welcome',
  vatValidation: 'vatValidation',
  payLater: 'payLater',
} as const

export const deliveryType = {
  email: 'email',
  eInvoice: 'einvoice',
  paper: 'paper',
  pdf: 'PDF',
  xml: 'XML',
  xRechnung: 'x-rechnung',
}

export const trackingFields = {
  category: Category,
  deliveryType,
  documentType: AnalyticsObject,
  name: Events,
  Modifiers,
  placement: Placement,
  result: Result,
  type: AnalyticsType,
}

export const PlacementsFromPath = {
  editor: 'editor',
  deliverynotes: 'deliverynotes',
  DraftPreview: 'preview', // TODO check that preview vs editor placements are correct
  invoiceFinancing: 'financing',
  myAccount: 'myAccount',
  productsAndServices: 'products',
  reactCustomers: 'customers',
  reactDashboard: 'dashboard',
  reactEstimateList: 'estimates',
  reactInvoice: 'editor',
  reactInvoiceList: 'invoices',
  reactRecurringProfiles: 'recurringProfiles',
  reactReports: 'reports',
  receipts: 'receipts',
  work: 'tracker',
} as const
